/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A proof of a credential. [Terminology](https://www.w3.org/TR/vc-data-integrity/#proofs).
 */
export interface CredentialProof {
    /** An identifier of the proof. */
    id?: string;
    /** The specific proof type used for cryptographic proof. */
    type: string;
}
